import PageSmartZones from "./PageSmartZones.vue";
import PageSmartZoneDrilldown from "./PageSmartZoneDrilldown.vue";
import PageZoneVideoPublic from "./PageZoneVideoPublic.vue";

const routes = {
  organization: [
    {
      path: "SmartZones",
      name: "SmartZones",
      component: PageSmartZones,
    },
    {
      path: "SmartZone/:smart_zone_id",
      name: "ViewSmartZone",
      component: PageSmartZoneDrilldown,
    },
  ],
  navigation: [
    {
      path: "/zone-video",
      name: "ZoneVideo",
      component: PageZoneVideoPublic,
      meta: { withoutAuth: true, standalone: true },
    },
  ],
};

export default routes;
